


import React, { useContext, useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import axios from "axios";
import Button from "../../../iconosv0/src/components/Button/Button.jsx";
import { AuthContext } from "./../AuthContext";
import { useTranslation } from "react-i18next";
import translations from "../../../utils/language/translations.json";
import "./stylesloin.scss";
import useGoogleScript from "../linking/useGoogleScript.js";

import InlineLoginOTP from "./InLineLoginOTP.jsx";
// ✅ use your dedicated screens
import ElementForgotPassword from "./recoveryv2/ElementForgotPassword";
import ElementResetPassword from "./recoveryv2/ElementResetPassword";
import ElementNewPassword from "./recoveryv2/ElementNewPassword";
import ElementRequestOTP from "./recoveryv2/ElementRequestOTP";

const SECRET_KEY = "whynotcoconut";
//const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID;
 const GOOGLE_CLIENT_ID =
   process.env.REACT_APP_GOOGLE_CLIENT_ID ||
   (typeof import.meta !== "undefined" ? import.meta.env?.VITE_GOOGLE_CLIENT_ID : undefined);
export default function ElementLogIn() {
  const navigate = useNavigate();
  const { login,isAuthenticated  } = useContext(AuthContext);
const [pendingEmail, setPendingEmail] = useState("");
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.Login?.[key]?.[currentLang] ?? key;

  // which screen to show
  const [view, setView] = useState("login"); // 'login' | 'forgot' | 'reset' | 'newpass' | 'requestotp'
const ready = useGoogleScript();
const googleBtnRef = useRef(null);
  // shared/local state
  const [email, setEmail] = useState("");
  const [emailForReset, setEmailForReset] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  const [message, setMessage] = useState("");

  // (optional) inline OTP for login email verification
  const [requiresVerification, setRequiresVerification] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const otpRefs = useRef([...Array(6)].map(() => React.createRef()));


    const eyeOpenIcon = () => {
      return (
 
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            fill="none"
            stroke="#fcfcfc"
            viewBox="0 0 24 24"
          >
            <g
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            >
              <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>{" "}
              <path d="M12.001 5C7.524 5 3.733 7.943 2.46 12c1.274 4.057 5.065 7 9.542 7 4.478 0 8.268-2.943 9.542-7-1.274-4.057-5.064-7-9.542-7z"></path>
            </g>
          </svg>

      );
    };
    const eyeClosedIcon = () => {
      return (
      
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="#ffffff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M2.999 3l18 18M9.843 9.914a3 3 0 004.265 4.22M6.5 6.646A10.024 10.024 0 002.457 12c1.274 4.057 5.065 7 9.542 7 1.99 0 3.842-.58 5.4-1.582m-6.4-12.369c.329-.032.663-.049 1-.049 4.478 0 8.268 2.943 9.542 7a9.954 9.954 0 01-1.189 2.5"
            ></path>
          </svg>
     
      );
    };



 const handleGoogleCredential = async (response) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/auth/google`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id_token: response.credential }),
      });
      const data = await res.json();
      if (data?.success) {
        // reuse your existing login path
        login(
  data.userId,
  data.userName,
  data.csrfToken,
  data.ProfilePicture,
  data.token,
  data.preferredCatalog || "Hockey",
  data.preferredLanguage || null
);
        // navigation will be handled by your isAuthenticated effect / or Navigate guard
      } else {
        setMessage("Google sign-in failed.");
      }
    } catch (e) {
      setMessage("Google sign-in error.");
    }
  };
 useEffect(() => {
   if (!ready) { console.log("[GIS] script not ready yet"); return; }
   if (!window.google?.accounts?.id) { console.warn("[GIS] window.google.accounts.id missing"); return; }
   if (!GOOGLE_CLIENT_ID) { console.error("[GIS] Missing GOOGLE_CLIENT_ID env"); return; }
 
   console.log("[GIS] Initializing with client", GOOGLE_CLIENT_ID);
    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: handleGoogleCredential,
      auto_select: false,
      ux_mode: "popup",
      context: "signin",
    });

    // Render a Google button into a container
   if (googleBtnRef.current) {
     window.google.accounts.id.renderButton(googleBtnRef.current, {
        theme: "filled_blue", size: "large", shape: "pill", text: "signin_with", locale: "en"
      });
     console.log("[GIS] Button rendered");
  } else {
     console.warn("[GIS] googleBtnRef not found");
    }

    // Optional: One Tap
    // window.google.accounts.id.prompt();
  }, [ready, GOOGLE_CLIENT_ID]);

  // load remembered
  useEffect(() => {
    const savedEmail = Cookies.get("rememberedEmail");
    const encPwd = Cookies.get("rememberedPassword");
    if (savedEmail && encPwd) {
      setEmail(savedEmail);
      try {
        const bytes = CryptoJS.AES.decrypt(encPwd, SECRET_KEY);
        const dec = bytes.toString(CryptoJS.enc.Utf8);
        if (dec) { setPassword(dec); setRememberMe(true); }
      } catch {}
    }
  }, []);

  const loginMutation = useMutation((formData) =>
    fetch(`${process.env.REACT_APP_API_BASE}/api/login2-test`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    }).then((r) => r.json())
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage("");

    if (!email.trim()) return setMessage(t("enterEmailError") || "Please enter your email.");
    if (!password.trim()) return setMessage(t("enterPasswordError") || "Please enter your password.");

    loginMutation.mutate(
      { email, password },
      {
     
      onSuccess: (data) => {
  if (data?.success) {
    login(
  data.userId,
  data.userName,
  data.csrfToken,
  data.ProfilePicture,
  data.token,
  data.preferredCatalog || "Hockey",
  data.preferredLanguage || null
);
    // set cookies, etc... but DON'T navigate here
    if (rememberMe) {
      Cookies.set("rememberedEmail", email, { expires: 30 });
      Cookies.set("rememberedPassword", CryptoJS.AES.encrypt(password, SECRET_KEY).toString(), { expires: 30 });
    } else {
      Cookies.remove("rememberedEmail");
      Cookies.remove("rememberedPassword");
    }
  } else if (data?.requiresVerification) {
 setPendingEmail(email);
            setView("otpLogin");
  } else {
    setMessage(t("invalidCredentials") || "Invalid credentials.");
  }
},
        onError: () => setMessage(t("loginFailed") || "Login failed."),
      }
    );
  };

useEffect(() => {
  if (isAuthenticated !== true) return;   // only redirect on strict true
  const intendedPath = localStorage.getItem("intendedPath") || "/home";
  localStorage.removeItem("intendedPath");
  navigate(intendedPath==="/login"?"/home":intendedPath, { replace: true });
}, [isAuthenticated, navigate]);





if (view === "otpLogin") {
    return (
      <main className="auth">
        <span aria-hidden className="page-bottom-glow" />
        <section className="container auth__container">
          <header className="auth__header">
            <h1>{t("enterOtpTitle") || "Enter verification code"}</h1>
            <p>{t("enterOtpSubtitle") || "We’ve emailed you a six-digit code."}</p>
          </header>

          <InlineLoginOTP
            email={pendingEmail}
            t={(k) => translations.Login?.[k]?.[currentLang] ?? k}
            onVerified={(payload) => {
              // payload should mirror /api/login2-test success shape

              console.log("OTP verified, logging in", payload);
              login(
                payload.userId,
                payload.userName,
                payload.csrfToken,
                payload.ProfilePicture,
                payload.token
              );
              // your isAuthenticated effect will redirect afterwards
            }}
          />

          <p className="auth__switch" style={{ marginTop: 12 }}>
            <button type="button" className="link" onClick={() => setView("login")}>
              {t("backToLogin") || "Back to login"}
            </button>
          </p>
        </section>
      </main>
    );
  }

  // —— view router: when not on “login”, just render your page components —— //
  if (view === "forgot") {
    return (
      <ElementForgotPassword
        setActiveView={setView}
        setEmailGlobal={setEmailForReset}
        t={(k) => translations.Login?.[k]?.[currentLang] ?? k}
         eyeClosedIcon={eyeClosedIcon}  eyeOpenIcon={eyeOpenIcon}
      />
    );
  }

  if (view === "reset") {
    return (
      <ElementResetPassword
        email={emailForReset || email}
        t={(k) => translations.Login?.[k]?.[currentLang] ?? k}
        onDone={() => setView("login")}
         eyeClosedIcon={eyeClosedIcon}  eyeOpenIcon={eyeOpenIcon}
      />
    );
  }

  if (view === "newpass") {
    return (
      <ElementNewPassword
        email={emailForReset || email}
        t={(k) => translations.Login?.[k]?.[currentLang] ?? k}
        onDone={() => setView("login")}
         eyeClosedIcon={eyeClosedIcon}  eyeOpenIcon={eyeOpenIcon}
      />
    );
  }

  if (view === "requestotp") {
    return (
      <ElementRequestOTP
        t={(k) => translations.Login?.[k]?.[currentLang] ?? k}
        eyeClosedIcon={eyeClosedIcon}  eyeOpenIcon={eyeOpenIcon}
      />
    );
  }

  // —— default: LOGIN screen (new responsive UI) —— //
  return (
    <main className="auth">
      <span aria-hidden className="page-bottom-glow" />

      <section className="container auth__container">
        <header className="auth__header">
          <h1>{t("titleLogin") || "Welcome Back, Collector"}</h1>
          <p>{t("subtitleLogin") || "Access your collection, manage trades, and track your sales."}</p>
        </header>

        <form className="auth__card" onSubmit={handleSubmit} noValidate>
          <div className="field">
            <label htmlFor="email">{t("usernameOrEmail") || "Email"}</label>
            <input
              id="email"
              name="email"
              type="text"
              placeholder={t("enterEmailPlaceholder") || "Enter your email"}
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="field">
            <label htmlFor="password">{t("password") || "Password"}</label>
            <div className="password-wrap">
              <input
                id="password"
                name="password"
                type={showPwd ? "text" : "password"}
                placeholder={t("enterPasswordPlaceholder") || "Enter your password"}
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="toggle-pwd"
                aria-pressed={showPwd}
                aria-label={showPwd ? (t("hidePassword") || "Hide password") : (t("showPassword") || "Show password")}
                onClick={() => setShowPwd((s) => !s)}
              >
                {!showPwd ? eyeClosedIcon() : eyeOpenIcon()}
              </button>
            </div>
          </div>

          <div className="auth__extras">
            <label className="remember">
              <input type="checkbox" checked={rememberMe} onChange={() => setRememberMe((v) => !v)} />
              <span>{t("rememberMe") || "Remember me"}</span>
            </label>

            <button
              type="button"
              className="link"
              onClick={() => { setEmailForReset(email || ""); setView("forgot"); }}
            >
              {t("forgotPassword") || "Forgot password?"}
            </button>
          </div>

          <button
  type="submit"
  className="btn-primary w-full"
  disabled={loginMutation.isLoading}
>
  {t("submit") || "Sign in"}
</button>
 
          {message ? <p className="auth__message">{message}</p> : null}
        </form>
 <div className="oauth-actions" style={{ marginTop: 12 }}>
   <div ref={googleBtnRef} />
   {/* Optional fallback for debugging */}
   {!GOOGLE_CLIENT_ID && (
     <button type="button" className="btn-secondary w-full" onClick={() => alert("Missing GOOGLE_CLIENT_ID env")}>
       Sign in with Google (env missing)
     </button>
   )}
 </div>
        <p className="auth__switch">
          {t("dontHaveAccount") || "First time here?"}{" "}
          <a href="/register">{t("joinNow") || "Join now"}</a>
        </p>
      </section>
    </main>
  );
}
